import { Dialog, Grid, IconButton, lighten, RadioGroup, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DetailsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const StatusContainer = styled(Grid)(
  {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    // "& .MuiTypography-root:nth-of-type(3)": {
    //   color: theme.palette.primary.main,
    // },
  })
);
export const Field = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  "& audio": {
    height: "35px",
  },
});

export const AddressedToContainer = styled(Grid)({
  display: "flex",
});

export const FieldsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.light,
  width: "235px",
  minWidth: "235px",
}));

export const DescriptionBlockContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: "5px",
}));

export const DescriptionLabelContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const DescriptionContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  position: "relative",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  padding: "8px",
  whiteSpace: "pre-line",
}));

export const SmallLabel = styled(Typography)(({ theme }) => ({
  fontSize: "10px",
  color: theme.palette.secondary.light,
  position: "absolute",
  top: "-10px",
  left: "10px",
  padding: "3px",
  backgroundColor: theme.palette.background.default,
}));

export const RecordedAudioContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  position: "relative",
  gap: "10px",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  flexDirection: "column",
  alignItems: "flex-end",
  width: "370px",
  "& audio": {
    height: "35px",
  },
  padding: "10px",
}));

export const RecordedAudioList = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  padding: "5px",
  alignSelf: "baseline",
  "& audio": {
    height: "35px",
    "&::-webkit-media-controls-enclosure": {
      borderRadius: "5px",
    },
  },
}));

export const ReportTypeContainer = styled(RadioGroup)(({ theme }) => ({
  display: "flex",
  flexFlow: "row nowrap",
  "& >.MuiGrid-root": {
    width: "50%",
    padding: "10px",
    border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    "&:first-of-type": {
      borderRadius: "8px 0px 0px 8px",
    },
    "&:last-of-type": {
      borderRadius: "0px 8px 8px 0px",
    },
    "& >.MuiFormControlLabel-root": {
      alignItems: "start",
      height: "50px",
      "& >span": {
        padding: "0px 5px",
      },
    },
  },
}));
export const UploadFilesContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  width: "100px",
  alignItems: "flex-end",
  position: "relative",
  padding: "10px",
}));

export const UploadedFilesContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "5px",
  flexDirection: "column",
  // border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
}));

export const SingleUploadedFile = styled(Grid)(({ theme }) => ({
  position: "relative",
  padding: "3px",
  borderRadius: "5px",
  display: "flex",
  justifyContent: "center",
  "&:hover": {
    "& .MuiIconButton-root": {
      opacity: 1,
    },
  },
}));

export const DeleteFileButton = styled(IconButton)(({ theme }) => ({
  opacity: 0,
  position: "absolute",
  top: 0,
  right: 0,
  height: "fit-content",
  width: "fit-content",
}));

export const DragNDropContainer = styled(Grid)({
  // width: "50%",
});

export const DocumentViewerContainer = styled(Dialog)(({ theme }) => ({
  width: "99vw",
  maxWidth: "99vw",
  "& .MuiPaper-root": {
    width: "97vw",
    maxWidth: "97vw",
  },
}));
